import React, { useState } from "react";
import { toast } from 'react-toastify';
import JsCodeEditor from "../../../components/JsCodeEditor";

const SettingTab = ({ handleLayoutChange, selectedLayout,updateNumberCounterTabData,numberCounterTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [animationSpeed, setAnimationSpeed] = useState(numberCounterTabData.animation_speed);
    const [animationSpeedDropdownOpen, setAnimationSpeedDropdownOpen] = useState(false);
    const [animationType, setAnimationType] = useState(numberCounterTabData.animation_type);
    const [animationTypeDropdownOpen, setAnimationTypeDropdownOpen] = useState(false);
    const [isEnableNumberFormatting, setIsEnableNumberFormatting] = useState(Number(numberCounterTabData.is_enable_number_formatting));
    const [languageType, setLanguageType] = useState(numberCounterTabData.language_type);
    const [languageTypeDropdownOpen, setLanguageTypeDropdownOpen] = useState(false);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(numberCounterTabData.custom_js);

    // Handlers animation Speed Change
    const handleAnimationSpeedChange = (font) => {
        setAnimationSpeed(font);
        updateNumberCounterTabData("animation_speed", font);
        setAnimationSpeedDropdownOpen(false);
    };

    // Handlers animation Type Change
    const handleAnimationTypeChange = (font) => {
        setAnimationType(font);
        updateNumberCounterTabData("animation_type", font);
        setAnimationTypeDropdownOpen(false);
    };

    //Handlers Enable Number Formatting Change
    const handleEnableNumberFormattingChange = (e) => {
        const checked = e.target.checked;
        setIsEnableNumberFormatting(checked);
        updateNumberCounterTabData("is_enable_number_formatting", checked); 
    };

    // Handlers Language Type Change
    const handleLanguageTypeChange = (font) => {
        setLanguageType(font);
        updateNumberCounterTabData("language_type", font);
        setLanguageTypeDropdownOpen(false);
    };

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateNumberCounterTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="side-baar-box-header">
                    <div className="box-header-row">
                            <span>Animation Speed</span>
                            <div className="color-pikr-box" onClick={() => setAnimationSpeedDropdownOpen(!animationSpeedDropdownOpen)}>
                                <em>{animationSpeed}</em>
                                {animationSpeedDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["1 Sec","2 Sec","3 Sec","4 Sec","5 Sec"].map((font) => (
                                            <li key={font} onClick={() => handleAnimationSpeedChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Animation Type</span>
                            <div className="color-pikr-box" onClick={() => setAnimationTypeDropdownOpen(!animationTypeDropdownOpen)}>
                                <em>{animationType}</em>
                                {animationTypeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Ease Out","Linear"].map((font) => (
                                            <li key={font} onClick={() => handleAnimationTypeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <p>Choose the animation type for the number display: linear (uniform motion) or ease out (gradual slowing down towards the end value).</p>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Enable Number Formatting</span>
                            <div className="form-group">
                                <input id="open_is_enable_number_formatting" className="chkbx-toggle" type="checkbox" checked={isEnableNumberFormatting} onChange={handleEnableNumberFormattingChange} />
                                <label for="open_is_enable_number_formatting"></label>
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Language</span>
                            <div className="color-pikr-box" onClick={() => setLanguageTypeDropdownOpen(!languageTypeDropdownOpen)}>
                                <em>{languageType}</em>
                                {languageTypeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["English"].map((font) => (
                                            <li key={font} onClick={() => handleLanguageTypeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;